module.exports = __webpack_public_path__ + "img/88f9d26.png";